// extracted by mini-css-extract-plugin
export default {"container":"GN-z","dimension":"HN-z","dimensionLabels":"IN-z"};